import { useEffect, useState } from 'react';
import { getAdMetrics } from 'api/marketing';
import { IAdMetricsQuery, IAdMetricsDisplay } from 'types/marketing';
import { convertAdMetricsToDisplay } from 'utils/marketing';

const useAdMetrics = (value: IAdMetricsQuery): [IAdMetricsDisplay, boolean, (params: IAdMetricsQuery) => void] => {
    const [loading, setLoading] = useState(false);
    const [metrics, setMetrics] = useState<IAdMetricsDisplay>({});

    const fetchData = async (params: IAdMetricsQuery) => {
        try {
            setLoading(true);
            const result = await getAdMetrics(params);
            if (!result.error) {
                setMetrics(convertAdMetricsToDisplay(result.data.data || {}, params.week));
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(value);
    }, []);

    return [metrics, loading, fetchData];
};

export default useAdMetrics;